(function () {
  "use strict";

  var FORM_ID = "XAfJsv";
  var SOURCE = "early_access_waitlist";
  var CONSENT_COPY = /yes,\s*i['\u2019]d like to receive human standard emails about product development/i;

  var INTEREST_BY_LABEL = {
    "Home Wellness Score\u2122 Pro": "score_pro",
    "Kitchen Reset Kit": "kitchen_reset_kit",
    "Sample Kits": "sample_kits",
    "Future Reset Kits (Bathroom, Laundry, etc)": "future_reset_kits",
    "Not sure yet": "not_sure"
  };

  var HOME_AREA_BY_LABEL = {
    "Kitchen": "kitchen",
    "Laundry": "laundry",
    "Bathroom": "bathroom",
    "Bedroom": "bedroom",
    "Kids' Spaces / Nursery": "kids_nursery",
    "Cleaning products": "cleaning_products",
    "Skincare": "skincare",
    "Water": "water",
    "Air Quality": "air",
    "Outdoors / Pest Control": "outdoor",
    "Not sure yet": "not_sure"
  };

  var INTEREST_LABELS = {
    score_pro: "Home Wellness Score\u2122 Pro",
    kitchen_reset_kit: "Kitchen Reset Kit",
    sample_kits: "Sample Kits",
    future_reset_kits: "Future Reset Kits (Bathroom, Laundry, etc)",
    not_sure: "Not sure yet"
  };

  var HOME_AREA_LABELS = {
    kitchen: "Kitchen",
    laundry: "Laundry",
    bathroom: "Bathroom",
    bedroom: "Bedroom",
    kids_nursery: "Kids' Spaces / Nursery",
    cleaning_products: "Cleaning products",
    skincare: "Skincare",
    water: "Water",
    air: "Air Quality",
    outdoor: "Outdoors / Pest Control",
    not_sure: "Not sure yet"
  };

  var pending = null;
  var posted = {};

  function config() {
    return window.HS_EARLY_ACCESS_INTAKE || {};
  }

  function formRoot() {
    return document.querySelector("[data-kn-form=\"early_access_waitlist\"]") ||
      document.querySelector(".klaviyo-form-" + FORM_ID) ||
      document.body;
  }

  function labelText(input) {
    var aria = (input.getAttribute("aria-label") || "").trim();
    if (aria) return aria;
    var id = input.id;
    if (id) {
      var byFor = document.querySelector('label[for="' + id + '"]');
      if (byFor) return (byFor.textContent || "").trim();
    }
    var parentLabel = input.closest("label");
    return parentLabel ? (parentLabel.textContent || "").trim() : "";
  }

  function normalizeLabel(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function uuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (ch) {
      var n = Math.random() * 16 | 0;
      var v = ch === "x" ? n : (n & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  function snapshotFields(root, detail) {
    var emailInput = root.querySelector("input[type=\"email\"]");
    var firstInput = root.querySelector("input[name*=\"first_name\" i], input[autocomplete=\"given-name\"], input[placeholder=\"First Name\"]");
    var freeform = root.querySelector("[id*=\"helpfulness_feedback\"], textarea[name*=\"helpfulness_feedback\"], input[name*=\"helpfulness_feedback\"]");
    var interestCodes = [];
    var interestLabels = [];

    root.querySelectorAll("input[type=\"checkbox\"][name*=\"primary_interest\"]").forEach(function (input) {
      if (!input.checked) return;
      var label = normalizeLabel(labelText(input));
      var code = INTEREST_BY_LABEL[label];
      if (!code || interestCodes.indexOf(code) !== -1) return;
      interestCodes.push(code);
      interestLabels.push(INTEREST_LABELS[code]);
    });

    var homeAreaCode = "";
    var homeAreaLabel = "";
    root.querySelectorAll("input[type=\"radio\"][name*=\"future_kit_interest\"]").forEach(function (input) {
      if (!input.checked) return;
      var label = normalizeLabel(labelText(input));
      var code = HOME_AREA_BY_LABEL[label];
      if (!code) return;
      homeAreaCode = code;
      homeAreaLabel = HOME_AREA_LABELS[code];
    });

    var explicitConsent = false;
    root.querySelectorAll("input[type=\"checkbox\"]").forEach(function (input) {
      var text = normalizeLabel(labelText(input));
      if (CONSENT_COPY.test(text) && input.checked) explicitConsent = true;
    });

    var email = String((emailInput && emailInput.value) || "").trim().toLowerCase();
    var firstName = String((firstInput && firstInput.value) || "").trim();
    var note = String((freeform && freeform.value) || "").trim();
    var meta = (detail && detail.metaData) || {};

    return {
      submission_id: (pending && pending.submission_id) || uuid(),
      email: email,
      first_name: firstName,
      form_id: FORM_ID,
      form_version_id: String(meta.formVersionId || meta.form_version_id || detail && detail.formVersionId || ""),
      page_url: String(meta.page || window.location.href || ""),
      source: SOURCE,
      explicit_email_consent: explicitConsent,
      interest_codes: interestCodes,
      interest_labels: interestLabels,
      home_area_code: homeAreaCode,
      home_area_label: homeAreaLabel,
      freeform_response: note,
      captured_at: Date.now()
    };
  }

  function rememberSnapshot(detail) {
    var next = snapshotFields(formRoot(), detail || {});
    if (!next.email || !next.interest_codes.length) return null;
    if (pending && pending.email === next.email && (Date.now() - pending.captured_at) < 8000) {
      next.submission_id = pending.submission_id;
      next.captured_at = pending.captured_at;
    }
    pending = next;
    return next;
  }

  function bodyFrom(payload) {
    return {
      submission_id: payload.submission_id,
      email: payload.email,
      first_name: payload.first_name,
      form_id: payload.form_id,
      form_version_id: payload.form_version_id,
      page_url: payload.page_url,
      source: payload.source,
      explicit_email_consent: payload.explicit_email_consent,
      interest_codes: payload.interest_codes,
      interest_labels: payload.interest_labels,
      home_area_code: payload.home_area_code,
      home_area_label: payload.home_area_label,
      freeform_response: payload.freeform_response
    };
  }

  function postSnapshot(payload) {
    var endpoint = String(config().endpoint || "").trim();
    if (!endpoint || !payload || posted[payload.submission_id]) return;
    posted[payload.submission_id] = true;
    try {
      fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyFrom(payload)),
        keepalive: true
      }).catch(function () {
        posted[payload.submission_id] = false;
      });
    } catch (_err) {
      posted[payload.submission_id] = false;
    }
  }

  function onNativeSubmit(detail) {
    var payload = rememberSnapshot(detail) || pending;
    if (!payload) return;
payload.explicit_email_consent = true;
postSnapshot(payload);
  }

  var SUCCESS_COPY = /you[\u2019']re on the list/i;
  var LEGAL_COPY = /unsubscribe|privacy policy/i;
  var centering = false;
  var suppressLibraryScroll = false;
  var nativeScrollIntoView = null;
  var protectY = null;
  var protectUntil = 0;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function waitlistRoot() {
    return document.querySelector("[data-kn-form=\"early_access_waitlist\"]") ||
      document.querySelector(".klaviyo-form-" + FORM_ID);
  }

  function headerOffset() {
    var raw = "";
    try {
      raw = getComputedStyle(document.body).getPropertyValue("--header-height") ||
        getComputedStyle(document.documentElement).getPropertyValue("--header-height");
    } catch (_err) {
      raw = "";
    }
    var parsed = parseFloat(raw);
    if (parsed > 0) return parsed;
    var header = document.querySelector("header-component, sticky-header, #header-component, #shopify-section-header");
    return header ? Math.max(0, header.getBoundingClientRect().height) : 0;
  }

  function normalizeText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function isWaitlistNode(node) {
    var root = waitlistRoot();
    return !!(root && node && root.contains(node));
  }

  function beginSuppressLibraryScroll() {
    suppressLibraryScroll = true;
    if (nativeScrollIntoView || !Element.prototype.scrollIntoView) return;
    nativeScrollIntoView = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {
      if (suppressLibraryScroll && isWaitlistNode(this)) return;
      return nativeScrollIntoView.apply(this, arguments);
    };
  }

  function endSuppressLibraryScroll() {
    suppressLibraryScroll = false;
    protectY = null;
    protectUntil = 0;
    if (!nativeScrollIntoView) return;
    Element.prototype.scrollIntoView = nativeScrollIntoView;
    nativeScrollIntoView = null;
  }

  function findSuccessHeadline() {
    var root = waitlistRoot();
    if (!root || !document.createTreeWalker) return null;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var best = null;
    var bestLen = Infinity;
    var node;
    while ((node = walker.nextNode())) {
      var text = normalizeText(node.nodeValue);
      if (!SUCCESS_COPY.test(text)) continue;
      var el = node.parentElement;
      if (!el) continue;
      if (text.length < bestLen) {
        best = el;
        bestLen = text.length;
      }
    }
    return best;
  }

  function findSuccessContainer() {
    return findSuccessHeadline();
  }

  function isLegalOnly(el) {
    var text = normalizeText(el && el.textContent);
    return !!(text && LEGAL_COPY.test(text) && !SUCCESS_COPY.test(text));
  }

  function hasFormControls(el) {
    return !!(el && el.querySelector && el.querySelector("input, textarea, select, button"));
  }

  function successCopyRect(headline) {
    var nodes = [headline];
    var parent = headline.parentElement;
    var root = waitlistRoot();
    if (parent && root && root.contains(parent) && parent !== root && parent.children && parent.children.length && parent.children.length <= 4) {
      var usable = [];
      var ok = true;
      for (var i = 0; i < parent.children.length; i++) {
        var kid = parent.children[i];
        if (hasFormControls(kid)) { ok = false; break; }
        if (isLegalOnly(kid)) break;
        usable.push(kid);
      }
      if (ok && usable.length) nodes = usable;
    }
    var top = Infinity;
    var bottom = -Infinity;
    for (var n = 0; n < nodes.length; n++) {
      var r = nodes[n].getBoundingClientRect();
      if (r.width < 1 && r.height < 1) continue;
      if (r.top < top) top = r.top;
      if (r.bottom > bottom) bottom = r.bottom;
    }
    if (!isFinite(top)) {
      var fallback = headline.getBoundingClientRect();
      top = fallback.top;
      bottom = fallback.bottom;
    }
    return { top: top, height: Math.max(0, bottom - top) };
  }

  function isHidden(el) {
    if (!el) return true;
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return true;
    try {
      var st = window.getComputedStyle(el);
      if (!st || st.display === "none" || st.visibility === "hidden" || Number(st.opacity) === 0) return true;
    } catch (_err) { /* ignore */ }
    return false;
  }

  function waitlistFieldsCollapsed(root) {
    if (!root) return true;
    var email = root.querySelector("input[type=\"email\"]");
    var submit = null;
    var buttons = root.querySelectorAll("button");
    for (var i = 0; i < buttons.length; i++) {
      if (/share input \+ join the list/i.test(buttons[i].textContent || "")) {
        submit = buttons[i];
        break;
      }
    }
    return isHidden(email) && isHidden(submit);
  }

  function layoutSignature(headline, root) {
    var rect = successCopyRect(headline);
    var sh = document.documentElement.scrollHeight || document.body.scrollHeight || 0;
    return [
      rect.top.toFixed(1),
      rect.height.toFixed(1),
      sh,
      waitlistFieldsCollapsed(root) ? "1" : "0"
    ].join("|");
  }

  function clampScrollY(y) {
    if (y < 0) y = 0;
    var max = Math.max(0, (document.documentElement.scrollHeight || document.body.scrollHeight) - window.innerHeight);
    if (y > max) y = max;
    return y;
  }

  function scrollSuccessIntoView(el) {
    var headline = el || findSuccessHeadline();
    if (!headline) return;
    var header = headerOffset();
    var rect = successCopyRect(headline);
    var pageTop = rect.top + window.pageYOffset;
    var visible = Math.max(160, window.innerHeight - header);
    var y = clampScrollY(pageTop - header - (visible / 2) + (rect.height / 2));
    window.scrollTo({
      top: y,
      behavior: prefersReducedMotion() ? "auto" : "smooth"
    });
    window.setTimeout(function () {
      protectY = y;
      protectUntil = Date.now() + 1200;
    }, prefersReducedMotion() ? 0 : 450);
    return y;
  }

  function watchSuccessThenCenter() {
    if (centering) return;
    centering = true;
    beginSuppressLibraryScroll();
    var root = waitlistRoot();
    var finished = false;
    var lastSig = "";
    var stable = 0;
    var started = Date.now();
    var maxWait = 4500;
    var interval = null;

    function cleanupWatchers() {
      if (obs) obs.disconnect();
      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    }

    function finish(headline) {
      if (finished) return;
      finished = true;
      cleanupWatchers();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (headline) scrollSuccessIntoView(headline);
          centering = false;
          window.setTimeout(endSuppressLibraryScroll, 1300);
        });
      });
    }

    function tick() {
      if (finished) return;
      var headline = findSuccessHeadline();
      if (headline) {
        var sig = layoutSignature(headline, root);
        if (sig === lastSig) stable += 1;
        else {
          lastSig = sig;
          stable = 0;
        }
        if (stable >= 4 && waitlistFieldsCollapsed(root)) {
          finish(headline);
          return;
        }
      }
      if (Date.now() - started > maxWait) {
        finish(headline || null);
      }
    }

    var obs = null;
    if (root && window.MutationObserver) {
      obs = new MutationObserver(tick);
      obs.observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
      });
    }
    interval = window.setInterval(tick, 50);
    tick();
  }

  document.addEventListener("scroll", function () {
    if (!protectUntil || Date.now() > protectUntil || protectY == null) return;
    if (Math.abs(window.pageYOffset - protectY) > 12) {
      window.scrollTo(0, protectY);
    }
  }, true);

  document.addEventListener("focusin", function (event) {
    if (!suppressLibraryScroll) return;
    var t = event.target;
    if (!isWaitlistNode(t) || !t || typeof t.focus !== "function") return;
    try {
      t.focus({ preventScroll: true });
    } catch (_err) { /* older browsers */ }
  }, true);

  document.addEventListener("click", function (event) {
    var button = event.target && event.target.closest && event.target.closest(".klaviyo-form-" + FORM_ID + " button, [data-kn-form=\"early_access_waitlist\"] button");
    if (!button) return;
    if (!/share input \+ join the list/i.test(button.textContent || "")) return;
    rememberSnapshot(null);
    watchSuccessThenCenter();
  }, true);

  window.addEventListener("klaviyoForms", function (event) {
    var detail = event && event.detail ? event.detail : {};
    var formId = String(detail.formId || detail.formID || "");
    if (formId && formId !== FORM_ID) return;
    var type = String(detail.type || "").toLowerCase();
    if (type === "submit") onNativeSubmit(detail);
    if (formId === FORM_ID && (type === "submit" || type === "stepsubmit" || type === "complete")) {
      watchSuccessThenCenter();
    }
  });

  window.HSEarlyAccessIntake = {
    INTEREST_BY_LABEL: INTEREST_BY_LABEL,
    HOME_AREA_BY_LABEL: HOME_AREA_BY_LABEL,
    INTEREST_LABELS: INTEREST_LABELS,
    HOME_AREA_LABELS: HOME_AREA_LABELS,
    findSuccessContainer: findSuccessContainer,
    scrollSuccessIntoView: scrollSuccessIntoView
  };
})();
